import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useState } from "react";
import './App.css';
import './WinOdometer.css';

const Wagers = (props) => {
    const [expandedRows, setExpandedRows] = useState({
        unallocated: true,
        allocated: true
    });

    const wagerName = (row) => {
        const first = row.FirstName || '';
        const last = row.LastName || '';
        return `${first} ${last}`.trim();
    };

    const RebetSwitch = (wgr) => {
        return (
            <div className="form-check form-switch">
                <input className="form-check-input" type="checkbox" role="switch" disabled={true} checked={!!wgr.AutoRebet}/>
            </div>
        );
    };

    const CoverSwitch = (wgr) => {
        return (
            <div className="form-check form-switch">
                <input className="form-check-input" type="checkbox" role="switch" disabled={true} checked={!!wgr.AutoCover}/>
            </div>
        );
    };

    const BingoSwitch = (wgr) => {
        return (
            <div className="form-check form-switch">
                <input className="form-check-input" type="checkbox" role="switch" disabled={true} checked={!!wgr.AutoBingo}/>
            </div>
        );
    };

    const groups = [
        {
            GroupKey: 'unallocated',
            GroupName: 'Unallocated',
            Count: (props.unallocWagers || []).length,
            Rows: props.unallocWagers || [],
            IsAllocated: false
        },
        {
            GroupKey: 'allocated',
            GroupName: 'Allocated',
            Count: (props.allocWagers || []).length,
            Rows: props.allocWagers || [],
            IsAllocated: true
        }
    ];

    const groupExpansionTemplate = (group) => {
        return (
            <div className="wagers-group-content">
                {group.IsAllocated && <div className="wagers-lock-note">Auto-play settings are locked after allocation.</div>}
                <div className="wagers-child-scroll">
                    <DataTable value={group.Rows || []} className="wagers-child-table" size="small" tableStyle={{ minWidth: group.IsAllocated ? '72rem' : '60rem' }}>
                        {group.IsAllocated && <Column header="Agent" body={(row) => row.ESS || row.Ess || ""}></Column>}
                        <Column header="Name" body={wagerName}></Column>
                        <Column header="Placement Time" field="CreatedAt"></Column>
                        <Column header="Amount" field="Amount"></Column>
                        <Column header="Auto-Cover" body={CoverSwitch}></Column>
                        <Column header="Auto-Rebet" body={RebetSwitch}></Column>
                        <Column header="Auto-Bingo" body={BingoSwitch}></Column>
                        {group.IsAllocated && <Column header="Activation Time" body={(row) => row.AssignedAt || ""}></Column>}
                    </DataTable>
                </div>
            </div>
        );
    };

    if (props.visible) {
        return (
            <div className="table-wrapper wagers-current-wrapper">
                <h4 className="table-name">Current Wagers</h4>
                <DataTable value={groups} dataKey="GroupKey" expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}
                           rowExpansionTemplate={groupExpansionTemplate} className="wagers-groups-table" size="small"
                           tableStyle={{ minWidth: '24rem' }}>
                    <Column expander style={{ width: '3rem' }}></Column>
                    <Column field="GroupName" header="Group"></Column>
                    <Column field="Count" header="Wagers"></Column>
                </DataTable>
            </div>
        );
    } else {
        return null;
    }
}

export default Wagers;
